import { SideNavItem } from './models/sideNavItem';

export const SIDENAV_ITEMS: Array<SideNavItem> = [
  {
    reportId: 'sellerTrustIndex',
    title: 'Seller Trust Index',
    id: 'seller-trust-index',
    mapId: 'seller-trust-index',
    active: false
  },
  {
    reportId: 'sellerMarketShare',
    title: 'Market Share',
    id: 'seller-market-share',
    mapId: 'seller-market-share',
    active: false,
    groups: ['app', 'ctv']
  },
  {
    reportId: 'sellerCoppaIndex',
    title: "Children's Privacy Index",
    id: 'seller-childrens-privacy',
    mapId: 'seller-childrens-privacy',
    active: false,
    groups: ['app'],
    icon: 'icon-childrens-privacy.svg'
  }
];
